import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Footer from './Footer';
import './Layout.css';

const Layout: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="nav-brand">
          <Link to="/">🦌 culr.app</Link>
        </div>
        <div className="nav-links">
          {isAuthenticated ? (
            <>
              <div className="nav-left">
                <Link to="/">Home</Link>
                <Link to="/dashboard">Dashboard</Link>
                <Link to="/data">Data</Link>
              </div>
              <div className="nav-center">
                <Link to="/add-cull" className="add-cull-btn">+ Add Cull</Link>
              </div>
            </>
          ) : (
            <>
              <Link to="/">Home</Link>
              <Link to="/map">Map</Link>
            </>
          )}
        </div>
        <div className="nav-auth">
          {isAuthenticated ? (
            <div className="user-menu">
              <span>Welcome, {user?.displayName || user?.email}</span>
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </div>
          ) : (
            <div className="auth-links">
              <Link to="/login">Login</Link>
            </div>
          )}
        </div>
      </nav>
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;